const he = {
  or: 'או',
  'auth.login': 'התחבר ב-SSO',
  'auth.accept': 'אני מאשר',
  'auth.terms': 'הסכם שימוש',
  'auth.forgotPassword': 'שכחתי סיסמה',
  'auth.privacyPolicy': 'מדיניות פרטיות',
  'auth.needHelp': 'Need help? Contact',
  'auth.support': 'Support',
  'auth.cookies': 'אנחנו משתמשי בעוגיות כדי לתת לך חוויה טובה יותר',
  'auth.terms.toastErrorMessage': 'יש להסכים לתנאי שימוש של השרות',
  'auth.redirectErrorToastMessage': 'An error occured during sign-in. Please try again or contact support.',

  'restore.title': 'איפוס סיסמה',
  'restore.updatePassword': 'עדכון סיסמה',

  'restore.validation.title': 'סיסמה חייבת להיות מורכבת מ',
  'restore.validation.minOf': 'לפחות',
  'restore.validation.characters': 'תווים',
  'restore.validation.lowerCase': 'אותיות קטנות',
  'restore.validation.upperCase': 'אותיות גדולות',
  'restore.validation.number': 'ספרות',
  'restore.validation.symbol': 'תווים מיוחדים',

  'resetPassword.expired.title': 'תוקף הסיסמה פג',
  'resetPassword.expired.description': 'יש להגדיר סיסמה חדשה כדי להמשיך להשתמש במערכת',

  'confirmSignIn.timer.title': 'אנא היכנס שוב אם לא קיבלת את הקוד',
  'confirmSignIn.rememberDevice': 'זכור אמצעי זה ל-14 ימים',

  'crashPage.somethingWrong': 'משהו השתבש',
  'crashPage.backToLogin': 'חזרה למסך הכניסה',
  'crashPage.contactAdmin': 'אנא פנה למנהל מערכת ההרשאות',

  'accessRestrictedByIp.title': 'כתובת ה-IP שלך אינה מורשית לגישה',
  'accessRestrictedByIp.contactInfo.prefix': 'צריך עזרה? פנה למשתמש האדמין שלכם בדוקה או',
  'accessRestrictedByIp.contactInfo.support': 'לתמיכה',
  'accessRestrictedByIp.backToLogin': 'חזרה למסך כניסה',

  'ssoFailurePage.title': 'אין הרשאת גישה למערכת',
  'ssoFailurePage.contactAdmin': 'אנא פנה למנהל מערכת ההרשאות',
  'ssoFailurePage.backToLogin': 'חזרה למסך הכניסה',

  'maintenance.title': 'המערכת לא זמינה כרגע',
  'maintenance.subtitle': 'אנו מבצעים שדרוג למערכת והיא צפויה לחזור להיות זמינה ב.',
  'maintenance.subtitle2': 'תודה על הסבלנות!',

  'forceNewPassword.newPassword.label': 'סיסמה חדשה',
  'forceNewPassword.newPassword.placeholder': 'הזן סיסמה חדשה',

  // fix default translate
  'Enter your Password': 'הכנס את הסיסמה שלך',
  'Enter your email': 'הכנס את המייל שלך',
  Code: 'קוד בן 6 ספרות',
  'Confirm Password': 'אישור סיסמה',
  'Change Password': 'הגדרת סיסמה חדשה',
  'Please confirm your Password': 'סיסמה חדשה',
  'Code *':
    'אנא הזן את קוד האימות שנשלח לכתובת הדוא"ל שלך. אם יש לך מספר טלפון שאושר, תוכל לקבל את הקוד גם בהודעת טקסט.',
  'New Password': 'סיסמה חדשה',
  'Confirm SMS Code': 'קוד אימות',
  'Incorrect username or password.': 'שם משתמש או סיסמה שגוים',
  'Invalid code or auth state for the user.': 'קוד אימות לא תקין, יש ללחוץ על קישור חזרה למסך הכניסה למערכת',
  'Invalid code provided, please request a code again.': 'קוד אימות לא תקין, יש ללחוץ על קישור חזרה למסך הכניסה למערכת',
  'Invalid verification code provided, please try again.': 'קוד אימות שגוי',
  'Back to Sign In': 'חזור למסך הכניסה למערכת',
  'Invalid session for the user, session is expired.': 'הפעלה שגוייה עבור המשתמש, פג תוקף קוד ההפעלה.',
  'User does not exist.': 'משתמש לא קיים',
  'Trial is expired.': 'תמה תקופת הנסיון',
  'Organization is not configured.': 'הארגון אינו מוגדר כהלכה',
  'Company is inactive.': 'החברה אינה פעילה',
  'Your organization has SSO enabled. You cannot login with password':
    'הכניסה למערכת רק תוך שימוש ב-SSO. לא ניתן להכנס עם משתמש וסיסמהץ',
  'Too many invalid credentials attempts. User temporarily locked. Please try again after few seconds.':
    'עקב ריבוי ניסיונות הזדהות כושלים החשבון נחסם לכמה שניות',
  'Rate exceeded': 'Login failed. Try again later.',
  'Too many requests': 'Login failed. Try again later.',

  'Network error':
    'cognito-idp.eu-west-1.amazonaws.com is blocked, please check your firewall settings or contact network administrator in your organization',
  'Attempt limit exceeded, please try after some time.':
    'הגישה נחסמה עקב ריבוי ניסיונות כושלים, יש לחזור על הפעולה בקרוב',
  'Temporary password has expired and must be reset by an administrator.':
    'הסיסמה הזמנית לא בתוקף. נא ללחוץ על כפתור ״שכחתי סיסמה״ כדי לשלוח סיסמה זמנית חדשה לכתובת המייל.',
  'Send code': 'שלח קוד אימות',
  'Access Token has been revoked': 'An error occured during sign-in. Please try again or contact support.',

  // Change Phone Page
  'phoneVerification.step1.title': 'אמת את מספר הטלפון שלך',
  'phoneVerification.step1.block1':
    'מטעמי אבטחת מידע, עלינו לאמת את מספר הטלפון הנייד שלך. נשלח לך קוד אימות באמצעות הודעת טקסט',
  'phoneVerification.step1.block2': 'Enter your phone number for 2 factor authentication:',
  'phoneVerification.step1.phone.placeholder': 'הזן את מספר הטלפון הנייד שלך',
  'phoneVerification.step1.sendButton': 'שלח קוד אימות',
  'phoneVerification.step1.verifyButton': 'אשר',
  'phoneVerification.step1.validation.genericError': 'עדכון מספר הטלפון נכשל',
  'phoneVerification.step1.backButton': 'לחזור למסך הזדהות',
  'phoneVerification.step2.title': 'הזן קוד אימות',
  'phoneVerification.step2.codeSentTo': 'שלחנו קוד בן 6 ספרות למספר',
  'phoneVerification.step2.validation.codeError': 'קוד שגוי או פג תוקף. אנא נסה שוב.',
  'phoneVerification.step2.validation.genericError': 'אירעה שגיאה בעת שליחת קוד האימות.',
  'phoneVerification.step2.changePhone': 'שינוי מספר הטלפון',
  'phoneVerification.skipButton': 'אעדכן בפעם אחרת',
  'footer.step2.noCodeReceived': 'לא קיבלת קוד?',
  'footer.step2.resendCode': 'שלח שוב',
  'footer.step2.changeNumber':
    'בהזנת מספר הטלפון שלך, אתה מסכים לקבל קוד חד־פעמי באמצעות הודעת טקסט (SMS) לצורך אימות החשבון שלך',
};

export default he;
